export default "__VITE_ASSET__c7096369__"